import React from "react";
import { MdAccessTime, MdCheckCircleOutline, MdErrorOutline, MdWarningAmber } from "react-icons/md";
import { Frescor } from "../../../../interfaces/Paineis";
import { tempoDesde } from "../logica";

export function formatarDataHora(iso: string): string {
  return new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
}

interface Props {
  frescor: Frescor;
  ultimoRefreshEm: string | null;
}

const BASE = "inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold";

/** Selo de frescor (texto + ícone, não só cor): Em dia, Atrasado, Falhou; sem SLA mostra "atualizado há X". */
const SeloFrescor: React.FC<Props> = ({ frescor, ultimoRefreshEm }) => {
  if (frescor === "EmDia") {
    return (
      <span className={`${BASE} bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300`}>
        <MdCheckCircleOutline className="h-3.5 w-3.5" aria-hidden="true" />
        Em dia
      </span>
    );
  }
  if (frescor === "Atrasado") {
    return (
      <span className={`${BASE} bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300`}>
        <MdWarningAmber className="h-3.5 w-3.5" aria-hidden="true" />
        Atrasado
      </span>
    );
  }
  if (frescor === "Falhou") {
    return (
      <span className={`${BASE} bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300`}>
        <MdErrorOutline className="h-3.5 w-3.5" aria-hidden="true" />
        Falhou
      </span>
    );
  }
  return (
    <span className={`${BASE} bg-gray-100 text-gray-600 dark:bg-navy-700 dark:text-gray-300`}>
      <MdAccessTime className="h-3.5 w-3.5" aria-hidden="true" />
      {ultimoRefreshEm ? `atualizado ${tempoDesde(ultimoRefreshEm)}` : "atualização desconhecida"}
    </span>
  );
};

export default SeloFrescor;
